
import { KulionerController } from "@/app/ui/controllers/KulionerController";
import { ReportController } from "@/app/ui/controllers/ReportController";
import { DownloadReportRequest } from "@/domain/entities/Kulioner";
import { Vue } from "vue-class-component";
import { formatDateNormal } from '@/app/infrastructures/misc/Utils';

export default class extends Vue {
  form = new DownloadReportRequest();
  setDateRange([startDate, endDate]: string[]) {
    this.form = new DownloadReportRequest({
      startDate,
      endDate
    });
  }

  onReset() {
    this.form = new DownloadReportRequest();

    const ref: any = this.$refs?.["kulioner-report-time-range-picker"];
    ref?.onSelectOption?.(ref?.options[0]);
    ref?.reset?.();
  }

  async onDownload() {
    try {
      const ref: any = this.$refs?.["kulioner-report-time-range-picker"];
      ref?.onClick?.();

      if (this.form.startDate && this.form.endDate)
        await KulionerController.getDownloadReports(
          new DownloadReportRequest({
            startDate: formatDateNormal(this.form.startDate, "YYYY-MM-DDTHH:mm:ssZ"),
            endDate: formatDateNormal(this.form.endDate, "YYYY-MM-DDTHH:mm:ssZ"),
          })
        );
      ReportController.setOpenDownloadRequest(true);
      ReportController.onGetListDownloadReport();
    } catch (error) {
      console.log("🚀 ~ extends ~ onDownload ~ error:", error);
    }
  }
}
